export var ivrsRelativePath = '/ivrs';
export var createIvrsApi = function (baseUrl, http) {
    var apiUrl = baseUrl + ivrsRelativePath;
    var ivrUrl = function (id) { return "".concat(apiUrl, "/").concat(id); };
    return {
        getFlows: function () {
            return http.get(apiUrl);
        },
        addFlow: function (addIvrFlowDto) {
            return http.post("".concat(apiUrl), addIvrFlowDto);
        },
        updateFlow: function (updateIvrFlowDto) {
            return http.put("".concat(ivrUrl(updateIvrFlowDto.id)), updateIvrFlowDto.data);
        },
        deleteFlow: function (ivrDto) {
            return http.delete("".concat(ivrUrl(ivrDto.id)));
        },
    };
};
//# sourceMappingURL=index.js.map